import './modalStyle.scss';

export default {
	content : {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		overflow: 'auto',
		maxWidth: '100%',
		maxHeight: '100%'
//		borderRadius: 0,
	},
	overlay: {
		backgroundColor: 'rgba(0,0,0,.75)'
	}
};